import React from 'react'

export default function ToggleSwitch ({className, title, handlerFunction}) {
	return(
		<div className={`selected-options-item ${className}`}>
			<span>{title}</span>
			<label className='toggle-switch'>
				<input className='checked' type='checkBox' onClick={handlerFunction}/>	
				<span className='slider'></span>
			</label>
		</div>
	);
}